module.exports = __webpack_public_path__ + "media/images/athletes/4174-938f31f83245e52612b4b9f1d644292d.png";